// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"2f87b24e","44":"47a74d69","53":"79488b7a","193":"d02dc829","249":"0b62f661","255":"b8ca253e","264":"37f67285","429":"a6bee22c","453":"0de00789","471":"53897187","532":"be2bb207","625":"dddfb539","867":"c8d5f153","931":"d5a179e1","965":"1fabb889"}[chunkId] + ".chunk.js";
};